(function (angular) {
    'use strict';

    angular
        .module('app.sitemap')
        .controller('app.sitemap.SitemapController', [
            '$scope',
            '$uibModal',
            sitemapController
        ]);

    function sitemapController($scope, $uibModal) {
        $scope.memberPortalUrl = environment.memberPortalUrl;
        $scope.discountSummaryUrl = siteContent.site.pages.welcome.discounts.left.button.link;

        $scope.launchInvite = launchInvite;

        // NOTE: The following functionality was copied and pasted over from 
        // app.controller.js.
        // At the time of this writing, this felt like the easier solution to bring
        // the sitemap online, as opposed to altering the app.controller and 
        // extracting the `launchInvite` functionality into a separate service.
        function launchInvite() {
            $uibModal.open({
                    templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-to-plan.html',
                    controller: 'app.purchase.InviteToPlanController',
                    controllerAs: 'vm'
                })
                .result
                .then(function fulfilled(result) {
                    if (result === true) {
                        $uibModal.open({
                            templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-success.html',
                            controller: 'app.purchase.InviteToPlanResponseController',
                            controllerAs: 'vm'
                        });
                    } else {
                        $uibModal.open({
                            templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-failure.html',
                            controller: 'app.purchase.InviteToPlanResponseController',
                            controllerAs: 'vm'
                        });
                    }
                });
        }
    }

})(angular);
